import React from 'react';
import { HashRouter, Routes, Route } from 'react-router-dom';
import { Layout } from './components/Layout';
import { HomePage } from './pages/HomePage';
import { ExperiencePage } from './pages/ExperiencePage';
import { AdvisoryPage } from './pages/AdvisoryPage';
import { ContactPage } from './pages/ContactPage';
export function App() {
  return <HashRouter data-id="element-0">
      <Layout data-id="element-1">
        <Routes data-id="element-2">
          <Route path="/" element={<HomePage data-id="element-4" />} data-id="element-3" />
          <Route path="/experience" element={<ExperiencePage data-id="element-6" />} data-id="element-5" />
          <Route path="/advisory" element={<AdvisoryPage data-id="element-8" />} data-id="element-7" />
          <Route path="/contact" element={<ContactPage data-id="element-10" />} data-id="element-9" />
        </Routes>
      </Layout>
    </HashRouter>;
}